import { PostMessageOptions } from "."

export function handleGetTheme({ props, data, source }: PostMessageOptions) {
    const { theme } = props

    if (data.getTheme) {
        if (source) {
            const { cms } = window.__MORPHEUS_CONTEXT__.config.params ?? {}
            source.postMessage({ theme, cms }, "*")
        }
    }
}
